<template lang="pug">
el-dialog(
  v-draggable,
  :close-on-click-modal="false",
  :close-on-press-escape="false"
  :fullscreen="fullscreen",
  custom-class="approve",
  :title="flowTitle",
  :style="propsStyles"
  :width="flowWidth",
  :visible.sync="flowDialog",
  @closed="reject()"
  :before-close="handleClose" )
  template(#title)
    .dialog-title
      .title {{ flowTitle }}
      span.flowStatus(:class="`type${status}`", v-if="flowType === 2||flowType === 3") {{ statusName(status) }}
      span(v-if="hasSelctor")
        span.selectorTitle 当前项目：
        prjIdSelect(:prjId="prjId", :readonly="flowType === 2||flowType === 3", @changeProject="changeProject" :key="flowType")
      .right(@dblclick.prevent.stop)
        el-dropdown.intervene(@command="handleCommand",trigger="click", size="mini" v-if="hasIntervene")
          el-button(size="small", type="primary" plain)
            | 流程干预
            i.el-icon-arrow-down.el-icon--right
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(v-for="item,index in interveneList" :title="item.name" :command="item.command" :key="index")
              .solt_item
                img(:src="item.image")
                span {{item.name}}
        el-button(size="small", type="primary",v-loading="temporaryLoading" plain, v-if="flowType===1||flowType===4",  @click="temporaryStorage") 暂存
        el-button(size="small", type="primary", v-if="withdrawBoolean", @click="withdraw") 撤回
        el-button(size="small", type="primary", v-if="flowAgainBoolean", @click="relaunch") 重新发起
        el-button(size="small", type="primary", v-if="flowType===1||flowType===4", @click="submitProcess") 提交并发起流程
        el-button(size="small", type="primary", v-if="flowType===5", @click="flowAgainSure") 流程再发起
  #summary
    addApproval(:class="{ fullscreen: fullscreen }" ref="addApproval",v-if="flowType === 1 || flowType === 4|| flowType === 5" :uuid="uuid" )
    flowDetail(:class="{ fullscreen: fullscreen }" ref="flowDetail", v-else,@closeDialog="closeDialog", :uuid="uuid" )
</template>

<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import flowDetail from "./flowDetail.vue";
import addApproval from "./addApproval.vue";
import prjIdSelect from "../config/prjIdSelect.vue";
import { summaryMixins } from "./mixins.js";
function num2px(number) {
  return typeof number === "number" ? `${number}px` : number;
}
export default {
  components: { flowDetail, addApproval, prjIdSelect },
  mixins: [asyncMixin, summaryMixins],
  props: {
    dialogHeight: {
      type: String,
      default: "660"
    },
    dialogWidth: {
      type: String,
      default: ""
    },
    // 弹框的唯一标识
    uuid: {
      type: String,
      default: ""
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      flowDialog: !false,
      temporaryLoading: false,
      interveneList: [
        { command: "rejectAdmin", name: "驳回", image: require("../image/rejectAdmin.png") },
        { command: "terminationAdmin", name: "终止", image: require("../image/terminationAdmin.png") },
        { command: "passNodeAdmin", name: "通过节点", image: require("../image/passNodeAdmin.png") },
        { command: "passAdmin", name: "通过流程", image: require("../image/passAdmin.png") }
      ]
    };
  },
  computed: {
    flowWidth() {
      return this.dialogWidth ? this.dialogWidth + "px" : "80%";
    },
    flowHeight() {
      return this.dialogHeight ? this.dialogHeight + "px" : "100%";
    },
    propsStyles() {
      return {
        "--v-draggable-height": num2px(this.flowHeight)
      };
    }
  },
  methods: {
    closeDialog() {
      this.resolve();
      this.handleClose();
    }
  }
};
</script>

<style lang="scss" scoped>
#summary {
  width: 100%;
  height: 100%;
  .fullscreen {
    height: 100%;
  }
}
.intervene{
  margin-right: 10px;
  cursor: pointer;
}
.approve {
  .el-dialog__body {
    padding: 10px 5px !important;
    border-bottom: 0 !important;
  }
}

.dialog-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 50px;

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    margin-right: 10px;
  }

  .right {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;

    .el-button {
      margin-left: 5px;
    }
  }
}
.solt_item{
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    margin-right: 5px;
  }
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,.type4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.type2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.type3 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.type9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.type0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}

.selectorTitle {
  font-size: 16px;
  line-height: 22px;
  margin-left: 20px;
  margin-right: 10px;
}
</style>
